import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { DEPARTMENT_ROUTE } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, DELETE, PUT } = HTTP_METHODS;
const { GET_DEPARTMENT } = DEPARTMENT_ROUTE;

export const departMentApi = createApi({
  reducerPath: 'departmentApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getDepartment: builder.query({
      query: (data) => ({ url: `${GET_DEPARTMENT}${buildQueryString(data)}`, method: GET })
    }),
    getDepartmentById: builder.query({
      query: (id) => ({
        url: `${GET_DEPARTMENT}/${id}`,
        method: GET
      })
    }),
    addDepartment: builder.mutation({
      query: (data) => ({ url: `${GET_DEPARTMENT}`, method: POST, data })
    }),
    deleteDepartment: builder.mutation({
      query: (id) => ({
        url: `${GET_DEPARTMENT}/${id}`,
        method: DELETE
      })
    }),
    editDepartment: builder.mutation({
      query: (data) => ({
        url: `${GET_DEPARTMENT}/${data.id}`,
        method: PUT,
        data: data?.data
      })
    })
  })
});

export const {
  useGetDepartmentQuery,
  useGetDepartmentByIdQuery,
  useAddDepartmentMutation,
  useDeleteDepartmentMutation,
  useEditDepartmentMutation
} = departMentApi;
